import { render, staticRenderFns } from "./headPageOwner.vue?vue&type=template&id=19c39d48&scoped=true"
import script from "./headPageOwner.vue?vue&type=script&lang=js"
export * from "./headPageOwner.vue?vue&type=script&lang=js"
import style0 from "./headPageOwner.vue?vue&type=style&index=0&id=19c39d48&prod&scoped=true&lang=css"
import style1 from "./headPageOwner.vue?vue&type=style&index=1&id=19c39d48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c39d48",
  null
  
)

export default component.exports